<template>
  <div class="project">
    <advertising-figure :bannerSrc="bannerSrc"/>
    <div class="inner-page-nav">
      <inner-page-nav />
    </div>
    <div class="inner-page-content">
      <public-title :title="title">
        <span class="sub">Overview of the meeting</span>
      </public-title>

      <div class="divider">
        <h2 class="tit">会议详情</h2>
        <span class="time"
          >发布日期: {{ simpleDateFormat(currentConference.update_time) }}</span
        >
      </div>

      <div class="meet-detail-wrap">
        <h2 class="tit">{{ currentConference.title }}</h2>
        <div class="meet-detail">
          <!-- <img
                        src="@assets/img/d1.jpg"
                        align="right"
                        width="300"
                        hspace="15"
                        vspace="15"
                    /> -->
          <p class="meet-item">
            <span class="small-tit">会议主题:</span>
            {{ currentConference.theme }}
          </p>
          <p class="meet-item">
            <span class="small-tit">会议时间:</span>
            {{ simpleDateFormat(currentConference.conferencedate) }}
          </p>
          <p class="meet-item">
            <span class="small-tit">会议地点:</span>
            {{ currentConference.address }}
          </p>
          <!-- <p class="meet-item">
            <span class="small-tit">会议介绍:</span>
          </p>
          <RichHtml class="meet-detail-wrap" :content="this.currentConference.content"></RichHtml> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import AdvertisingFigure from "@components/advertising"
  import InnerPageNav from "@components/tool-nav"
  import publicTitle from "@components/title"
  import CurrentConferMixin from "@/mixin/CurrentConference"
  import RichHtml from "@/components/RichHtml"

  export default {
    name: "MeetDetailPage",
    components: {
      AdvertisingFigure,
      InnerPageNav,
      publicTitle,
      RichHtml
    },
    mixins: [CurrentConferMixin],
    data() {
      return {
        bannerSrc:require("@assets/img/meeting-banner.png"),
        title: "会议概况",
      }
    },

    methods: {},
  }
</script>

<style lang="scss" scoped>
  @import "@assets/scss/innerpagenav.scss";

  .inner-page-nav {
    position: relative;
    width: 1200px;
    height: 60px;
    padding: 0 15px;
    margin: 0 auto;
  }

  .inner-page-content {
    margin: 60px 0;
  }

  .divider {
    @include flex-between;
    width: 1200px;
    height: 50px;
    line-height: 50px;
    padding: 0 15px;
    margin: 30px auto 60px;
    border-bottom: 1px solid #eee;

    .tit {
      position: relative;
      font-size: 18px;
      color: #666;

      &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 30px;
        height: 2px;
        background: $defaultColor;
      }
    }

    .time {
      font-size: 14px;
      color: #999;
    }
  }

  .meet-detail-wrap {
    width: 1200px;
    margin: 0 auto;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);

    .meet-detail {
      width: 100%;
      padding: 30px;
    }

    .tit {
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      display: inline-block;
      min-width: 180px;
      font-size: 20px;
      margin: 30px 0;
      color: $defaultColor;
      padding: 0 30px;
      text-align: center;

      &:before {
        content: "";
        position: absolute;
        top: 50%;
        left: -100px;
        width: 100px;
        height: 2px;
        background: linear-gradient(to right, transparent, #ccc);
      }

      &:after {
        content: "";
        position: absolute;
        top: 50%;
        right: -100px;
        width: 100px;
        height: 2px;
        background: linear-gradient(to left, transparent, #ccc);
      }
    }

    .meet-item {
      font-size: 14px;
      color: #666;
      margin-bottom: 15px;
      line-height: 30px;

      .small-tit {
        color: $defaultColor;
      }
    }
    .small-tit1 {
      margin-left: 100px;
      color: $defaultColor;
    }
  }
</style>
